import { render, staticRenderFns } from "./OwnerSelect.vue?vue&type=template&id=1f8d1d4c&"
import script from "./OwnerSelect.vue?vue&type=script&lang=ts&"
export * from "./OwnerSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports